Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSharedStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useSharedStyles = exports.useSharedStyles = function useSharedStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var imageWidth = 160;
  if (bp.is([bp.mobile_xl])) {
    imageWidth = 200;
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    imageWidth = 300;
  }
  var textContainer = {
    textAlign: 'center',
    maxWidth: _styles.STYLES.grid.maxBoxWidth,
    marginBottom: spacing.l
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    textContainer.marginBottom = spacing.xl;
  }
  if (bp.desktop) {
    textContainer.textAlign = 'left';
  }
  var logo = {
    width: 142,
    height: 35,
    marginBottom: spacing.l
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    logo.width = 192;
    logo.height = 46;
  }
  if (bp.tablet) {
    logo.marginBottom = spacing.xl;
  }
  if (bp.desktop) {
    logo.marginBottom = spacing.xxl;
  }
  var sharedStyles = _reactNative.StyleSheet.create({
    textContainer: textContainer,
    logo: logo
  });
  return {
    sharedStyles: sharedStyles,
    imageWidth: imageWidth
  };
};